export default "__VITE_ASSET__BY$1dQTq__"